<!--
   Created by qing on 2020/12/21
   Des: 选择创建item
-->
<template>
  <van-popup
    class="select-node-item-popup"
    v-model="visible"
    get-container="body"
    safe-area-inset-bottom
    :style="{ height: 'calc(270px + env(safe-area-inset-bottom))', width: '100%' }"
    position="bottom">
    <div class="select-node-item-container">

      <div
        class="content-container"
        v-for="item in dataList"
        :key="item.name">
        <div class="title">
          {{item.name}}
        </div>
        <div class="child-container">
          <div
            class="child"
            v-for="child in item.children"
            :key="child.name"
            @click="onClickCreateItem(child)">

            <img class="child-img" :src="child.icon" alt="">
            <div class="child-name">
              {{child.name}}
            </div>
          </div>
        </div>
      </div>

      <div class="cancel-button" @click="close">
        取消
      </div>
    </div>
  </van-popup>
</template>

<script>
  import {
    MIX_FORM_ITEM_TYPE_APPLY,
    MIX_FORM_ITEM_TYPE_ATTACHMENT, MIX_FORM_ITEM_TYPE_DASHBOARD, MIX_FORM_ITEM_TYPE_DATA,
    MIX_FORM_ITEM_TYPE_IMAGE,
    MIX_FORM_ITEM_TYPE_MEMO, MIX_FORM_ITEM_TYPE_MIX_FORM,
    MIX_FORM_ITEM_TYPE_NODE, MIX_FORM_ITEM_TYPE_VIEW
  } from "../../store/types";

  export default {
    props: {
      mixFormId: {
        type: String,
        default: ''
      },
      stackList: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        visible: false,

        dataList: [
          {
            name: '新建',
            children: [
              {
                name: '下级目录',
                icon: `${this.$BASE_PATH}/fetch/image?id=385820683759779841.png`,
                type: MIX_FORM_ITEM_TYPE_NODE
              },
              {
                name: '附件',
                icon: `${this.$BASE_PATH}/fetch/image?id=385474843157463041.png`,
                type: MIX_FORM_ITEM_TYPE_ATTACHMENT
              },
              {
                name: '图片附件',
                icon: `${this.$BASE_PATH}/fetch/image?id=386450757433425921.png`,
                type: MIX_FORM_ITEM_TYPE_IMAGE
              },
              {
                name: '备忘录',
                icon: `${this.$BASE_PATH}/fetch/image?id=385471373633388545.png`,
                type: MIX_FORM_ITEM_TYPE_MEMO
              },
              {
                name: '发起表单',
                icon: `${this.$BASE_PATH}/fetch/image?id=385822473121169409.png`,
                type: MIX_FORM_ITEM_TYPE_APPLY
              }
            ]
          },
          /*
          {
            name: '关联',
            children: [
              {
                name: this.$store.getters.mix_form_name,
                icon: '/form/fetch/image?id=385824054537355265.png',
                type: MIX_FORM_ITEM_TYPE_MIX_FORM
              },
              {
                name: '表单数据',
                icon: '/form/fetch/image?id=385471373633388548.png',
                type: MIX_FORM_ITEM_TYPE_DATA
              },
              {
                name: '表单视图',
                icon: '/form/fetch/image?id=385823258571742273.png',
                type: MIX_FORM_ITEM_TYPE_VIEW
              },
              // {
              //   name: '待办视图',
              //   icon: '/form/fetch/image?id=385474122756430913.png',
              //   type: MIX_FORM_ITEM_TYPE_TODO
              // },
              {
                name: '仪表盘',
                icon: '/form/fetch/image?id=385473228111347713.png',
                type: MIX_FORM_ITEM_TYPE_DASHBOARD
              }
            ]
          }
           */
        ],
      }
    },
    created() {
    },
    methods: {
      open() {
        this.visible = true
      },
      close() {
        this.visible = false
      },
      onClickCreateItem(item) {
        this.close()
        this.$emit('selectItem', item)
      },
    }
  }
</script>

<style lang="less">

  .select-node-item-popup {
    /*background-color: #F6F6F6 !important;*/

    .select-node-item-container {
      width: 100%;
      height: 100%;
      position: relative;
      background-color: #fff;

      > .content-container {
        margin-bottom: 20px;
        padding: 10px;

        .title {
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 20px;
        }

        .child-container {
          display: flex;
          flex-wrap: wrap;

          .child {
            width: calc(100% / 3);
            cursor: pointer;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin: 10px 0;

            .child-img {
              width: 40px;
              height: 40px;
              object-fit: cover;
              border-radius: 4px;
              margin-bottom: 10px;
            }

            .child-name {
              font-size: 14px;
              color: #6d6d6d;
            }
          }
        }
      }

      .cancel-button {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 14px;
        color: #6d6d6d;
        border-top: 1px solid #e6e6e6;
      }
    }
  }
</style>